import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Luxembourg: Country = {
    identifier: "Luxembourg",
    name: "Luxembourg",
    countryCode: "LU",
    group: CountryGroup.EUROPE,
    isUNMember: true,
    flag: "🇱🇺",
    svgPath: "m 492.06075,300.7024 -0.022,0.117 0.004,0.261 0.079,0.261 0.188,0.258 0.143,0.186 0.193,0.149 0.326,0.141 0.13,0.03 0.018,0.191 -0.025,0.202 -0.113,0.111 -0.106,0.161 -0.08,0.195 -0.083,0.375 -0.012,0.259 -0.188,-0.107 -0.099,-0.073 -0.172,-0.02 -0.171,0.06 -0.128,0.131 -0.177,0.04 -0.145,-0.04 -0.086,-0.098 -0.077,-0.053 -0.219,-0.066 -0.095,-0.143 0.073,-0.067 0.062,-0.106 0.053,-0.149 0.067,-0.137 -0.215,-0.379 -0.045,-0.116 -0.176,-0.213 0.002,-0.109 0.042,-0.103 -0.016,-0.081 0.025,-0.191 0.124,-0.181 0.082,-0.224 0.139,-0.306 0.307,-0.368 0.22,0.057 0.097,-0.002 0.058,0.135 z",
}
